export default class ListItem {
  public id: number;

  public text: string = '';

  public isActive: boolean = false;

  constructor(id: number, text: string, isActive: boolean = false) {
    this.id = id;
    this.text = text;
    this.isActive = isActive;
  }

  get getToggleClass(): string {
    return this.isActive ? 'carousel__item--active' : 'carousel__item--hidden';
  }
}
